// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__4QomI","opacity-transition":"success_opacity-transition__P4I6K"};